<template>
  <div >

    <v-container grid-list-md>
      <div xs6 class="btn-tool ml-3 text-xs-left mt-5 pt-4">
        <router-link :to="'/teacherprofile/'+teacherId+'#calender'" class="no-deraction">
          <v-icon class="textColor pt-2 f-30">fas fa-arrow-left</v-icon>
        </router-link>
      </div>
      <v-layout wrap>
        <v-flex xs12 lg4>
          <v-card class="pa-4 card-r mt-2">
          <v-layout wrap xs12 class="layout-invoice-contant text-xs-left" >
            <v-flex xs12 class="pa-0 pl-2 pb-2">
              <span class="pr-3">Date:- <code class="text-xs-right ml-3"> {{selectedBooking.date}}</code></span>
            </v-flex>
            <v-flex xs12 class="pa-0 pl-2 pb-2">
              <v-flex xs12 class="pa-0 pl-2 pb-2">
                <span class="pr-3">Day:- <code class="text-xs-right ml-3"> {{selectedBooking.day}}</code></span>
              </v-flex>
              <span class="pr-3">Time from:- <code class="text-xs-right ml-3"> {{selectedBooking.time_from}}</code></span>
            </v-flex>
            <v-flex xs12 class="pa-0 pl-2 pb-2">
              <span class="pr-3">Time to:- <code class="text-xs-right ml-3"> {{selectedBooking.time_to}}</code></span>

            </v-flex>
            <v-flex xs12 class="pa-0 pl-2 pb-2">
              <span class="pr-3">Minutes :- <code class="text-xs-right ml-3"> {{selectedBooking.hours}}</code></span>
            </v-flex>

          </v-layout>

        </v-card>
        </v-flex>
        <v-flex xs12 lg8 xs12>
          <v-card class="card-r mt-2 pa-3 ">
            <v-container fulied class="pa-0">
              <v-layout wrap >
            <v-flex xs12 lg6 md6 class="">
              <v-autocomplete
                prepend-icon="fas fa-graduation-cap"
                :items="studentsList"
                item-text="name"
                item-value="id"
                @input="filterPackage(selectedStudent)"
                v-model="selectedStudent"
                class="ma-0 pr-2 pt-4 pl-3 white w-100"
                label="Select Student"
                placeholder="Type student Name">
              </v-autocomplete>
            </v-flex>
            <div v-if="noPackageMsg" style="color:white;background-color:red;padding:5px;">
              {{noPackageMsg}}
            </div>
            <v-flex xs12 lg6 md6 class="">
              <v-select
                :items="studentPackages"
                item-text="packageName"
                item-value="package_id"
                v-model="selectedPackage"
                @input="filterModule(selectedPackage)"
                placeholder="Select Package"
                prepend-icon="fas fa-circle"
                class="ma-0 pr-2 pt-4 pl-3 white w-100"
              >
              </v-select>
            </v-flex>
            <v-alert v-if="noModules" type="info" :value=true> There are no modules for booking </v-alert>
            <v-flex xs12 lg6 md6 class="">
              <v-select
                :items="studentModules"
                item-text="name"
                item-value="id"
                v-model="selectedModule"
                placeholder="Select Module"
                prepend-icon="fas fa-circle"
                class="ma-0 pr-2 pt-4 pl-3 white w-100"
              >
              </v-select>
            </v-flex>
                <v-flex d-flex xs12 lg6 md6>
                  <v-btn @click="AddStudent" larg depressed class="no-shadow h-50p card-r text-white" color="primary">ADD student</v-btn>
                </v-flex>

            <!-- <v-flex d-flex lg4 sm4 xs12 class="textFeald date">
              <v-menu
                ref="menu1"
                v-model="birthday"
                :close-on-content-click="false"
                lazy
                full-width
                persistent
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dob"
                  class=""
                  label="Select Date"
                  persistent-hint
                  value="John Doe"
                  outline
                  placeholder="dd/mm/yyyy"
                ></v-text-field>
                <v-date-picker  v-model="dob" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="birthday = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="setdate(dob)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex d-flex lg4 sm4 xs12 class="textFeald w-100">
              <v-select
                v-model="timeselect"
                :items="timeslot"
                class="input-group--focused w-100"
                placeholder="select your time"
                outline
              ></v-select>
            </v-flex> -->
            <v-flex v-if="alertType">
              <v-alert
                :value="true"
                color="success"
                icon="check_circle"
                outline
                v-if="alertType=='success'"
              >
                {{msg}}
              </v-alert>
              <v-alert
                :value="true"
                color="error"
                icon="warning"
                outline
                v-if="alertType=='warning'"
              >
                {{msg}}
              </v-alert>
            </v-flex>

              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  /* eslint-disable */
  import HotelDatePicker from 'vue-hotel-datepicker'
  import {mapState} from 'vuex'
  import api from "@/utils/backend-api"
  import router from "@/router"
  export default {
    props:['id','teacherId'],
    data() {
      return {
        menu1: '',
        dob: "",
        model:false,
        birthday: false,
        timeselect: "",
        yourValue: "",
        whats_app: ['Student Name 1 ', 'Student Name 2' , 'Student Name 3' , 'Student Name 4' , 'Student Name 5' , 'Student Name 6' , 'Student Name 7'],
        timeslot: ["07:00 am", "08:00 am", "09:00 am", "10:00 am", "11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm"],
        selectedStudent:'',
        studentPackages:[],
        selectedPackage:'',
        studentModules:[],
        selectedModule:'',
        studentTime:[],
        alertType:'',
        msg:'',
        selectedBooking:'',
        noPackageMsg:'',
        studentsList:[],
        noModules:false
      }
    },
    created:function(){
      console.log(this.id)
      let id=this.id
      let teacherId=this.teacherId
      let self=this
      api.getData('admin/calender/slot/'+id)
      .then(res=>{
        this.selectedBooking=res.data
      })
      api.postData('admin/teacher_students',{teacher_id:teacherId})
      .then(res=>{
        // self.studentsList.push(res.data[0].active_students)
        // let studentList={...res.data[0].active_students,...res.data[0].pending_students}
        let active=res.data[0].active_students
        let pending=res.data[0].pending_students
        self.studentsList=active.concat(pending)
      }).catch(err=>{

      })
    },
    methods: {
      AddStudent(){
        let self=this
          const postData={
              student_id:this.selectedStudent,
              package_id:this.selectedPackage,
              module_id:this.selectedModule,
              teacher_bookings_id:this.id
          }
          api.postData('admin/student_class/book',postData)
          .then(res=>{
              if(res.status==201){
                self.alertType="success"
                self.msg="Successfully Added"
                setTimeout(()=>{
                  router.push('/teacherprofile/'+self.teacherId+'#calender')
                },500);
              }else if(res.status==200){
                self.alertType="warning"
                self.msg=res.data.error.message
                // this.msg="Failed"
              }
          }).catch(err=>{
            this.alertType="warning"
            // debugger
            try{
              if(res.status==200){
                  self.alertType="warning"
                  self.msg=res.data.error.message
              }else{
                self.msg="Failed"
              }
            }catch(ex){
                self.alertType="warning"
                self.msg="Failed to book"
            }
            // debugger
          })
      },
      filterPackage(selectedStudent){
          this.studentPackages=[]
          console.log(selectedStudent)
          api.getData('admin/student_package/'+selectedStudent)
          .then(res=>{
            // debugger
            if(res.status==200){
              // console.log(res.data)
              // debugger
                res.data.forEach((element,index)=>{
                    let Data={
                        packageName:element.packages.name,
                        package_id:element.package_id,
                        // classDetails:element.class_details
                    }
                    console.log(Data)
                    this.studentPackages.push(Data)
                })
                // let Data={
                //   bookedPackages:res.data.booked_package
                // }
            }
          }).catch(err=>{
              this.noPackageMsg="No more packages bought to book class"
          })
      },
      filterModule(selectedPackage){
        // console.log(selectedPackage)
        let moduleList=[]
        let Data={
          student_id:this.selectedStudent,
          package_id:selectedPackage
        }

        let self=this
        api.postData('admin/student_class',Data)
        .then(res=>{
          if(res.status==200){
            moduleList=res.data.non_booked_modules
            self.studentModules=res.data.non_booked_modules
            if(self.studentModules.length==0){
              self.noModules=true
            }else{
              self.noModules=false
            }
          }

          // moduleList.forEach(element=>{
          //   if(element.package_id==selectedPackage){
          //     // let modules=element.classDetails.non_booked_modules
          //     modules.forEach(element=>{
          //       console.log(element)
          //       self.studentModules.push(element)
          //     })
          //   }
          // })
        })

        // let self=this

      },
      setdate(value) {
        console.log(value)
        // this.$refs.menu1.save(value)
        this.dob = value
        this.birthday = false

      }
    },
    computed:{
      ...mapState([
        'Students'
      ])
    },
    components:{
      HotelDatePicker
    }
  }
</script>
<style>
  .datepicker__input {
    -webkit-appearance: none !important;
  }
  .datepicker__close-button {
    top: 10px!important;
    font-weight: unset!important;
    font-size: 30px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/teacher/FreeSlots.vue